
import { useRouter } from "vue-router";
import { inject, toRefs } from "vue";
export default {
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
    status_name: {
      type: String,
      default: "",
    },
    random: {
      type: Number,
    },
  },
  setup(props: any, { emit }: any) {
    const router = useRouter();
    //获取货币
    const $store: any = inject("$store");
    let { item } = toRefs(props)
    const currencyUnit: String = $store.getSymbol();
    let unifiedJump = (val: any) => {
      $store.setDetails({ ...val.goods });
      router.push({
        name: "goods",
        params: {
          id: val.goods_id,
        },
      });
    };
    let get_price_type_fn = ()=>{
          var new_user_price= item.value.goods.newuser_price ? item.value.goods.newuser_price : '';
                var normal_price= new_user_price ? new_user_price : item.value.price
                var market_price= item.value.goods.price_market ? item.value.goods.price_market :item.value.goods.goods_marketprice;
                normal_price = ((market_price-normal_price)/market_price)*100;  
                return  parseInt(normal_price);
    }
    get_price_type_fn()
    return {
      currencyUnit,
      unifiedJump,
      get_price_type_fn
    };
  },
};
